import {
  ModalSheet,
  ModalSheetHeader,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
  ModalSheetContentDescription,
  ModalSheetFooter,
  ModalSheetFooterSpacer,
  ModalSheetFooterButtonGroup,
} from '@/components/ModalSheet'
import { Button } from '@/components/Button'
import { byDesign } from '@/infra/design'
import imgConfirmActionUrl from '@/assets/misc/img_confirm-action.svg'
import WorkspaceRolesIllustration from '@/components/SpotIllustration/WorkspaceRolesIllustration'

export interface OCRConfirmBulkRerunDialogProps {
  showing: boolean
  selectedCount: number
  onClose: () => unknown
  onConfirm: () => unknown
}

export function OCRConfirmBulkRerunDialog({
  showing,
  selectedCount,
  onClose,
  onConfirm,
}: OCRConfirmBulkRerunDialogProps) {
  return (
    <ModalSheet
      showing={showing}
      onRequestClose={onClose}
      disableCloseOnOutsideClick
    >
      <ModalSheetHeader withCloseButton />
      <ModalSheetContent>
        <ModalSheetContentBlock>
          <ModalSheetContentIllustration
            src={imgConfirmActionUrl}
            illustration={byDesign(undefined, WorkspaceRolesIllustration)}
          />
          <ModalSheetContentTitle>
            You are about to rerun {selectedCount} jobs
          </ModalSheetContentTitle>
          <ModalSheetContentDescription>
            Are you sure you want to proceed?
          </ModalSheetContentDescription>
        </ModalSheetContentBlock>
      </ModalSheetContent>

      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button label="Close" onPress={onClose} />
          <Button label="Rerun" variant="primary" onPress={onConfirm} />
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
}
